module.exports = __webpack_public_path__ + "static/img/baselineRepair_pic07.cb5fad3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/baselineRepair/baselineRepair_pic07.png
// module id = 472
// module chunks = 1